import { ShieldCheck } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { useSafetyNotes } from "../lib/siteContent";

const PET = "pet";
const keyFor = (cat) => (["supplies-services", "lost-found", "iso"].includes(cat) ? cat : PET);

export const SafetyNote = ({ category }) => {
  const { lang } = useLanguage();
  const notes = useSafetyNotes();
  if (!notes) return null;
  const t = notes[lang] || notes.en;
  return (
    <div className="mt-4 rounded-xl bg-[#12234A] px-4 py-3.5" data-testid="listing-safety-note">
      <p className="flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wider text-slate-300"><ShieldCheck size={14} className="text-[#F5551E]" /> {t.title}</p>
      <p className="mt-1.5 text-sm leading-snug text-white/90" data-testid="listing-safety-text">{t[keyFor(category)] || notes.en[keyFor(category)]}</p>
    </div>
  );
};
